<template>
  <div class="help">
    <div class="left">
      <div class="top-title">平台使用文档</div>
      <Menu
        theme="light"
        ref="side_menu"
        class="mt-30"
        :open-names="openNames"
        :active-name="activeName"
        @on-select="handleMenu"
      >
        <Submenu v-for="(item, index) in menuList" :key="index" :name="index">
          <template slot="title">
            <span class="title">{{ item.title }}</span>
          </template>
          <MenuItem
            v-for="(it, idx) in item.subList"
            :key="idx"
            :name="`${index}-${idx}`"
            class="menu-item"
            ><div class="ellipsis">{{ it.title }}</div>
            <img
              v-if="activeName === `${index}-${idx}`"
              src="@/assets/menu_bg.png"
              class="active-bg"
          /></MenuItem>
        </Submenu>
      </Menu>
    </div>
    <div class="right">
      <Card :bordered="false" dis-hover>
        <div slot="title" class="flex-row">
          <div class="line"></div>
          <div class="ml-10 card-title">{{ title }}</div>
        </div>
        <div class="content" v-html="content">
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import { menuList } from "./config";
export default {
  data() {
    return {
      menuList,
      activeName: this.$route.query.activeName || "0-0",
      // openNames: [0]
    };
  },

  computed: {
    title() {
      let idxArr = this.activeName.split("-");
      return this.menuList[idxArr[0]].subList[idxArr[1]].title;
    },

    content() {
      let idxArr = this.activeName.split("-");
      return this.menuList[idxArr[0]].subList[idxArr[1]].content;
    },

    openNames() {
      let openNames = [Number(this.activeName.split('-')[0])]
      return openNames
    }
  },

  watch: {
    $route: {
      handler: function(val) {
        this.activeName = val.query.activeName || '0-0'
      }
    },

    openNames() {
      this.$nextTick(() => {
        this.$refs.side_menu.updateOpened();
        this.$refs.side_menu.updateActiveName();
      })
    }
  },

  methods: {
    handleMenu(e) {
      if (this.activeName === e) return
      this.activeName = e;
      this.$router.push({
        name: "help",
        query: { activeName: this.activeName },
      });
    }
  },
};
</script>

<style lang="less" scoped>
.help {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
}

.left {
  width: 270px;
  height: 100%;
  background: #fff;
  padding-left: 30px;
  padding-top: 30px;
  padding-bottom: 30px;
  overflow: scroll;
  .top-title {
    font-size: 20px;
    margin-left: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 30px;
  }

  .title {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 30px;
  }

  .menu-item {
    position: relative;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 25px;
  }

  .active-bg {
    position: absolute;
    left: 0;
    top: -25px;
    width: 240px;
    height: 100px;
    z-index: -1;
  }
}

.right {
  position: relative;
  width: ~"calc(100% - 270px)";
  height: 100%;
  padding: 20px;

  .ivu-card {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .line {
    width: 3px;
    height: 20px;
    background: #613ea4;
  }

  .card-title {
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 30px;
  }

  .content {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 32px;
    text-indent: 32px;
  }
}
</style>

<style lang="less">
.help {
  .ivu-menu-light.ivu-menu-vertical
    .ivu-menu-item-active:not(.ivu-menu-submenu) {
    color: #fff;
    background: transparent;
    z-index: 0;
    // background-image: url("../../assets/menu_bg.png");
    // background-repeat: no-repeat;
    // background-size: 240px 110px;
    // background-position: center;
  }

  .ivu-menu-light.ivu-menu-vertical
    .ivu-menu-item-active:not(.ivu-menu-submenu):after {
    background: transparent;
  }

  .ivu-menu-vertical .ivu-menu-item:hover,
  .ivu-menu-vertical .ivu-menu-submenu-title:hover {
    color: #515a6e;
    opacity: 0.8;
  }

  .ivu-menu-opened {
    .title {
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
  }

  .ivu-card-body {
    width: 100%;
    height: ~"calc(100% - 60px)";
    overflow: scroll;
  }
}
</style>